/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S5_I2_TextInputs */

const tr_kullanim_s5_i2_text = /** @type {(inputs: Kullanim_S5_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 73/A uyarınca yetkili tüketici mahkemeleri ve tüketici hakem heyetleri geçerli olup, yukarıdaki yetki sözleşmesi tüketiciler bakımından hüküm ifade etmez.`)
};

const en_kullanim_s5_i2_text = /** @type {(inputs: Kullanim_S5_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pursuant to 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 73/A, the competent consumer courts and consumer arbitration committees apply, and the above jurisdiction clause has no effect with regard to consumers.`)
};

const de_kullanim_s5_i2_text = /** @type {(inputs: Kullanim_S5_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 73/A sind die zuständigen Verbrauchergerichte und Verbraucherschiedsausschüsse maßgeblich; die vorstehende Gerichtsstandsvereinbarung entfaltet gegenüber Verbrauchern keine Wirkung.`)
};

const ru_kullanim_s5_i2_text = /** @type {(inputs: Kullanim_S5_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Согласно 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 73/A применяются компетентные потребительские суды и потребительские арбитражные комиссии, а вышеуказанное соглашение о подсудности не имеет силы в отношении потребителей.`)
};

/**
* | output |
* | --- |
* | "Pursuant to 6502 sayılı Tüketicinin Korunması Hakkında Kanun Madde 73/A, the competent consumer courts and consumer arbitration committees apply, and the abo..." |
*
* @param {Kullanim_S5_I2_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s5_i2_text = /** @type {((inputs?: Kullanim_S5_I2_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S5_I2_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s5_i2_text(inputs)
	if (locale === "de") return de_kullanim_s5_i2_text(inputs)
	if (locale === "ru") return ru_kullanim_s5_i2_text(inputs)
	return tr_kullanim_s5_i2_text(inputs)
});